import { usePost } from "@/api/lib/integration";

export const storeQuiz = usePost<{ fragen: Record<string, unknown> }, void>('/api/pflegevorsorge');
